<template>
  <!--在右侧的时候-->
  <span
    class="btn"
    data-io-click="tracker"  @click="collectHandle"
    :class="{ active: collected }"
    v-if="themeType === 0"
  >
    <i
      class="iconfont"
      :class="[
        collected ? 'icon-' + activeIconClass : 'icon-' + defaultIconClass,
      ]"
    />
    <span class="text">{{ collected ? "已收藏" : "收藏" }}</span>
  </span>
</template>

<script>
import request from "@/utils/request";
import api from "@/assets/js/service/api";
export default {
  props: {
    userRoleStatus: {
      type: Boolean,
      default: false,
    },
    userLoginStatus: {
      type: Boolean,
      default: false,
    },
    // 收藏状态
    collected: {
      type: Boolean,
      default: false,
    },
    // 资料id
    documentId: {
      type: [Number, String],
      default: 0,
    },
    defaultIconClass: {
      type: String,
      default: "collect1",
    },
    activeIconClass: {
      type: String,
      default: "collect-filled",
    },
    //样式类型
    themeType: {
      type: Number,
      default: 0,
    },
    // 来源类型
    sourceTypeId: {
      type: Number,
      default: 1,
    },
    // 学段
    stageId: {
      type: String,
      default: "2",
    },
    contentType: {
      type: Number,
      default: null,
    },
  },
  methods: {
    async collectHandle() {
      if (!this.userLoginStatus) {
        this.$emit("toLogin");
        return;
      }
      if (!this.userRoleStatus) {
        this.$emit("collectBtnDialog");
        return;
      }
      console.log("接口路径");
      //   try {
      let method = this.collected
        ? request.postJson.bind(request)
        : request.post;
      // let method = request.postJson;
      let contentType = this.contentType
        ? this.contentType
        : this.stageId === 2
        ? 2
        : 1;
      let params = this.collected
        ? {
            contentId: this.documentId,
            contentType,
          }
        : {
            contentId: this.documentId,
            sourceTypeId: this.sourceTypeId,
            contentType,
          };
      let url = this.collected ? api.collect.cancel : api.collect.add;
      let result;
      console.log("接口路径" + url);
      method(url, params).then((res) => {
        if (res.state) {
          if (res.result) {
            this.$emit("modifyCollectedState", !this.collected);
          } else {
            this.$message("收藏失败");
          }
        }
      });
      //     if (result.data.status) {
      //       this.$emit('modifyCollectedState', result.data, !this.collected);
      //     } else {
      //       this.$showToast(result.data.message);
      //     }
      //   } catch (error) {
      //     let data = error.response;
      //     if (data.status == 401) {
      //       // window.location.href = constants.loginUrl;
      //       let currentUrl = window.location.href.replace(
      //         /https?:\/\/.*\.zxxk.com/gi,
      //         ''
      //       );
      //       xkw.redirectToLoginUrl(currentUrl, this);
      //     }
      //   }
      //   }
      // this.$emit('modifyCollectedState', result.data, !this.collected);
    },
  },
};
</script>
<style lang="scss" scoped>
.btn {
  text-align: center;
  color: #1a1a1a;
  border-radius: 4px;
  padding: 4px 6px;
  cursor: pointer;

  .iconfont {
    margin-right: 4px;
  }
  .text {
    color: #1a1a1a;
  }
  &.active {
    .iconfont {
      color: #0057ff;
      margin-right: 5px;
    }
    .text {
      color: #80848b;
    }
  }
  &:hover {
    background: #eff1f4;
    .text {
      color: #0057ff;
    }

    .iconfont {
      color: #0057ff;
    }
  }
}
</style>
